import { render, staticRenderFns } from "./ItemsManager.vue?vue&type=template&id=64cf832a&"
import script from "./ItemsManager.vue?vue&type=script&lang=js&"
export * from "./ItemsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports